var app = angular.module("KimaMain", [
	'ngRoute',
	'ngAnimate',
	'ngTouch',
	'ngSanitize',
	'angular-templates',
	'rzModule',
    'slick',
	], ['$interpolateProvider', function($interpolateProvider) {
		$interpolateProvider.startSymbol('[[').endSymbol(']]');
	}]
);


app.config(
	["$sceDelegateProvider", function($sceDelegateProvider) {
		$sceDelegateProvider.resourceUrlWhitelist([
    			'self',
    			'https://www.kiinteistomaailma.fi/**',
    			'http://www.kiinteistomaailma.fi/**'
		]);
	}]
);
app.config(
	["$locationProvider", function($locationProvider) {
		if(navigator.appName.indexOf("Internet Explorer") === -1) {
			$locationProvider.html5Mode({
				enabled: true,
				rewriteLinks: false
			});
		} else if(navigator.appVersion.indexOf("MSIE 10.0") !== -1) {
			$locationProvider.html5Mode({
				enabled: true,
				rewriteLinks: false
			});
		}
	}]
);
app.run(["$rootScope", function ($rootScope) {
	$rootScope.useWindowLocation = true;
	if(navigator.appName.indexOf("Internet Explorer") === -1) {
		$rootScope.useWindowLocation = false;
	} else if(navigator.appVersion.indexOf("MSIE 10.0") !== -1) {
		$rootScope.useWindowLocation = false;
	}

	var ua = navigator.userAgent;
	var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

	window.isIE = is_ie;

	if (is_ie) {
		document.documentElement.className += ' is-ie';
		var containers = document.querySelectorAll('[data-packery-settings]');
		var packeryScript = document.getElementById('packerysrc');
		packeryScript.src = "https://unpkg.com/packery@2/dist/packery.pkgd.min.js";

		var imgsLoaded = document.getElementById('imagesloadedsrc');
		var packerys = [];
		imgsLoaded.addEventListener("load", function (event) {
			var imgLoad = imagesLoaded(containers, function () {
				for (var i = 0, l = containers.length; i < l; i++) {
					var options = JSON.parse(containers[i].dataset.packerySettings) || {};
					delete options.autoInitLayout;

					packerys[i] = new Packery(containers[i], options);
				}
			});
		});
		imgsLoaded.src = "https://unpkg.com/imagesloaded@4/imagesloaded.pkgd.min.js";
	}
}]);